import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ServiceMessageBrokerFactory,
  ServiceMessageBroker,
} from "shared/provider-webworker";
import { IFindActionService, FIND_ACTION } from "../IFindActionService";
import { CubiqWorker } from "../../worker/CubiqWorker";
import { TraderGroupLookupService } from "../../lookup/model/impl/TraderGroupLookupService";

import { Subject } from "rxjs";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

export abstract class FindActionPromiseService implements IFindActionService {
  abstract findDeals(data: any): Promise<any>;
  abstract findOrders(data: any): Promise<any>;
}
